import { ErrorMessage } from 'formik';
import React from 'react';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const Error = ({ children }) => {
  const inner = typeof children === 'string' ? capitalizeFirstLetter(children) : children;

  return <div className="my-1 text-red-600">{inner}</div>;
};

const FormError = ({ name, ...props }) => <ErrorMessage component={Error} name={name} {...props} />;

export const FormErrorBase = Error;
export default FormError;
